import React from 'react';
import { Link } from 'react-router-dom';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003').replace(/\/$/, '');

export default function ForgotPasswordPage() {
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [success, setSuccess] = React.useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || 'Nem sikerült elküldeni a visszaállító emailt.');
      setSuccess(data?.message || 'Ha az email létezik, elküldtük a visszaállító linket.');
    } catch (err) {
      setError(err.message || 'Hiba történt.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-page">
      <div className="auth-card">
        <h1>Elfelejtett jelszó</h1>
        <p className="admin-note">Add meg az email címed, és küldünk visszaállító linket.</p>
        {error && <div className="admin-error">{error}</div>}
        {success && <div className="admin-note">{success}</div>}
        <form onSubmit={onSubmit} className="auth-form">
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <button type="submit" className="primary-btn" disabled={loading}>
            {loading ? 'Küldés…' : 'Visszaállító link küldése'}
          </button>
        </form>
        <p className="auth-links">
          <Link to="/login">Vissza a bejelentkezéshez</Link>
        </p>
      </div>
    </main>
  );
}
